import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=864fb1b0&scoped=true&"
import script from "./ToolBar.vue?vue&type=script&lang=js&"
export * from "./ToolBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864fb1b0",
  null
  
)

export default component.exports